// const baseBackURL = "/admin";

const baseUrl = "https://pyatnashka.md/api_2";
// "http://localhost:1198/api_2";
// "http://192.168.1.5:1198/api_2";

// "http://194.156.67.209";
// "http://192.168.1.6:1198/api_2";

// const basePort =
//":5000";

const baseBackURL = `${baseUrl}/admin`;

const endpoints = {
  bilet: `${baseBackURL}/bilet`,
  biletQuestions: `${baseBackURL}/bilet-to-question`,
  theme: `${baseBackURL}/theme`,
  themeToQuestion: `${baseBackURL}/theme-to-question`,
  question: `${baseBackURL}/question`,
  answer: `${baseBackURL}/answer`,
  pdd: `${baseBackURL}/pdd`,
  pddTheme: `${baseBackURL}/pdd-theme`,
  pddSubtheme: `${baseBackURL}/pdd-theme/subtheme`,
  mediaTree: `${baseBackURL}/pdd/media-tree`,
  login: `${baseUrl}/api/admin/login`,
  image: `${baseUrl}/image`,
  video: `${baseBackURL}/video`,
  news: `${baseBackURL}/news`,
  newsCategory: `${baseBackURL}/news/theme`,
  newsToCategory: `${baseBackURL}/news-to-theme`,
  user: `${baseBackURL}/user`,
  userCredit: `${baseBackURL}/user/credit`,
  userRecover: `${baseBackURL}/user/recovery`,
  userGroup: `${baseBackURL}/user-to-group`,
  school: `${baseBackURL}/school`,
  schoolGroup: `${baseBackURL}/school/group`,
  schoolCredits: `${baseBackURL}/school/credit`,
  schoolLesson: `${baseBackURL}/lesson`,
  category: `${baseBackURL}/category`,
  order: `${baseBackURL}/order`,
  studentImage: `${baseBackURL}/student_image`,
  drivingTime: `${baseBackURL}/user/driving_time`,
  docGeneration: `${baseBackURL}/contract`,
  unlimSession: `${baseBackURL}/unlim_session`,
  auto: `${baseBackURL}/auto`,
  enablePracticeToGroup: `${baseBackURL}/school/enable_practice`,
};

const uploaderType = {
  video: 1,
  image: 2,
};

const userRole = {
  0: "Админ",
  1: "Ученик",
  2: "Директор автошколы",
  3: "Администратор автошколы",
  4: "Преп. теории",
  5: "Преп. практики",
};

export const colorToStatus = {
  delete: "#e6e6e6",
  block: "#ffcccc",
  notAllFields: "#ffffcc",
  toVerify: "#ccccff",
};

const docType = {
  study: 0,
  practice: 1,
  anceta: 2,
  secureData: 3,
  driverCard: 4,
  GAITheoryDeclaration: 5,
  GAIPractice: 6,
};

export const drivingLesson = [
  {
    id: 0,
    title: "Автодром автошколы",
    color: "#81C784",
    colorSoft: "#d8ebd1",
  },
  { id: 1, title: "Основное вождение", color: "#64B5F6", colorSoft: "#a6ddf5" },
  { id: 2, title: "Доп. вождение", color: "#FFB74D", colorSoft: "#fadaa7" },
  { id: 3, title: "Экзамен", color: "#E57373", colorSoft: "#f0d6d5" },
];

export const statusColors = {
  success: "#388e3c",
  error: "#d32f2f",
  warning: "#f57c00",
  base: "#0288d1",
  disabled: "#616161bf",
};

export const drivingLessonStatus = [
  { id: 0, title: "Активно" },
  { id: 1, title: "Завершен" },
  { id: 2, title: "Отменен" },
];

const fileTreeEntityType = {
  file: 0,
  folder: 1,
};

const findInTree = (stack, id, type) => {
  for (const node of stack) {
    if (node) {
      // 1. Проверяем текущий узел
      if (node.id === id && node.type === type) {
        return node;
      }

      // 2. Если есть дети, идем вглубь
      if (node.children && node.children.length > 0) {
        const result = findInTree(node.children, id, type);
        if (result) return result; // Если нашли в глубине, прокидываем наверх
      }
    }
  }

  return null; // Ничего не нашли
};
export {
  userRole,
  findInTree,
  endpoints,
  uploaderType,
  baseUrl,
  docType,
  fileTreeEntityType,
};
